module.exports = __webpack_public_path__ + "img/max-cloud-repeat.ddae53c5.svg";